import { UNIFIED_TEMPLATES_API_PATH } from "src/constants";

export const isUnifiedTemplatesAPIPreviewImage = (url: string) => {
  return url?.includes(`${UNIFIED_TEMPLATES_API_PATH}/media`);
};
